import { render, staticRenderFns } from "./AddDataCommonNames.vue?vue&type=template&id=6a600436&"
import script from "./AddDataCommonNames.vue?vue&type=script&lang=js&"
export * from "./AddDataCommonNames.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports